import React from "react";
import TableNumberBase2 from "../TableNumberBase2";
import "./TableTextBase.css";

function TableTextBase() {
  return (
    <div className="table-text-base">
      <TableNumberBase2 />
    </div>
  );
}

export default TableTextBase;
